<style scoped lang="scss">
  .wrap-products{
    .container{
      width:1000px;
    }
    .mr41{
      float: left;
      display: block;
    }
    .cons{
      display: none;
    }
    @media
    screen and (max-width: 375px) and (min-width: 374px),
    screen and (max-width: 414px) and (min-width: 413px),
    screen and (max-width: 640px) and (min-width: 600px),
    screen and (min-width: 300px) and (max-width:400px)
    {
      .con{
        display: none!important;
      }
      .cons{
        display: block!important;
      }
      section{
        padding-top: 10px!important;
      }
    }
    .mr42{
      display: none;
    }
    .xia{
      display: none;
    }
    .bts{
      display: block;
      width: 18%;
    }
    .top-con{
      display: flex;
    }
    .pro-img{
      width:390px;
      margin-right: 40px;
      .img-preview{
        width:390px;
        height:390px;
      }
      .swiper-img{
        width:66px;
        height:66px;
        cursor: pointer;
        border: 4px solid #fff;
        &.active{
          border-color:#014492;
        }
      }
      img{
        display: block;
        font-size: 0;
      }
      ul{
        display: flex;
        margin:20px -10px 0;
        li{
          margin:0 10px;
          cursor: pointer;
          border:4px solid #fff;
          &.active{
            border-color:#014492;
          }
        }
        img{
          width:120px;
          height:120px;
        }
      }
    }
    .pro-info{
      .title{
        font-size: 30px;
        font-weight: bold;
        margin-top: 14px;
      }
      .price{
        font-size: 24px;
        font-weight: bold;
        color: #014492;
        margin: 30px 0 50px;
      }
    }
    .el-input-number{
      width:90px;
    }
    .details{
      padding:10px 40px 20px;
      margin-top: 40px;
      background: #F9F9F9;
    }
    .context{
      p{
        margin-bottom:15px;
        line-height: 1.8;
      }
    }
    .down-lists{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li{
        width:46%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
      }
    }
    .el-tab-pane{
      padding-top: 10px;
    }
    .specs{
      display: flex;
      align-items: center;
      ul{
        display: flex;
        li{
          border: 1px solid #D8DCE6;
          border-radius: 4px;
          height:32px;
          line-height: 32px;
          padding:0 10px;
          margin-right: 20px;
          cursor: pointer;
          &.active{
            color: #13489d;
            border-color: #13489d;
            background: rgba(19, 72, 157, 0.1);
          }
        }
      }
    }
  }
  @media screen and (max-width: 640px){
    .wrap-products{
      .container{
        width: 90% !important;
      }
      #pane-first img{
        width: 100%;
      }
      .top-con {
        display: block!important;
      }
      .pro-info .title{
        font-size: 20px!important;
      }
      .pro-info .price{
        font-size: 16px!important;
      }
      .details {
        line-height: 25px;
        padding: 10px 10px 20px!important;
      }
      .down-lists li{
        display: block!important;
        width: 100% !important;
      }
      .pro-img .img-preview{
        width: 100% !important;
      }
      .pro-img{
        width: 100% !important;
      }
      .el-tab-pane{
        p{
          img{
            width: 100%;
          }
        }
      }
    }
    .mr42{
      float: left;
      display: block!important;
    }
    .mr41{
      display: none!important;
    }
    .mt30{
      overflow: auto;
    }
    .xia{
      margin-top: 10px;
      display: block!important;
    }
    .bts{
      display: none!important;
    }
    .container>>> .el-tabs__item{
      padding: 0 10px!important;
    }
    .container>>> img{
      width: 100%;
    }
  }
</style>
<style lang="scss">
.wrap-products{
  .swiper-button-next, .swiper-button-prev{
    color:#fff;
    &:after{
      font-size: 24px;
    }
  }
}
</style>
<template>
  <div class="wrap wrap-products">
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <div class="top-con">
        <div class="pro-img">
          <pic-zoom :url="details.imgUrls[currentPro]" class="img-preview" :scale="3"></pic-zoom>
<!--          <img :src="details.imgUrls[currentPro]" class="img-preview">-->
          <swiper ref="mySwiper" :options="swiperOptions" style="margin-top: 15px;">
            <swiper-slide v-for="(item, index) in details.imgUrls" :key="index" @click.native="currentPro = index">
              <img :src="item" class="swiper-img" :class="{active: currentPro === index}">
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev" @click="swiperPrev" v-if="details.imgUrls.length > 4"></div>
            <div class="swiper-button-next" slot="button-next" @click="swiperNext" v-if="details.imgUrls.length > 4"></div>
          </swiper>
        </div>
        <div class="pro-info">
          <div class="title">{{details.name}}</div>
          <div class="price">¥ {{details.skus[currentSpecs].priceY}}</div>
          <p>货号：{{details.skus[currentSpecs].code}}</p>
          <div class="specs mt30">
            <label>规格：</label>
            <ul>
              <li v-for="(item, index) in details.skus" :key="item.id" :class="{active: currentSpecs === index}" @click="currentSpecs = index">{{item.spec}}</li>
            </ul>
          </div>
<!--          <div class="num mt30">-->
<!--            <label>数量：</label>-->
<!--            <el-input-number v-model="num" controls-position="right" @change="handleChange" :min="1" :max="10"></el-input-number>-->
<!--          </div>-->
          <div class="mt30">
<!--            <el-button type="primary" size="mini" class="mr42" plain @click="handleCartChange">加入购物车</el-button>-->
<!--            <el-button type="primary" size="mini" class="mr42" @click="toBuy">立即购买</el-button>-->
<!--            <el-button type="primary" class="mr41" plain @click="handleCartChange">加入购物车</el-button>-->
<!--            <el-button type="primary" class="mr41" @click="toBuy">立即购买</el-button>-->
            <div class="con">
              <el-button type="primary"   plain @click="shop">前往擎科科邦邦商城下单</el-button>
            </div>
            <div class="cons">
              <el-button type="primary" size="mini"  plain @click="shop">前往擎科科邦邦商城下单</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="details">
        <el-tabs v-model="activeName">
          <el-tab-pane label="产品简介" name="first" v-html="details.title"></el-tab-pane>
          <!-- <el-tab-pane label="实验案例" name="third" v-html="details.demo"></el-tab-pane> -->
          <!-- <el-tab-pane label="常见问题" name="second" v-html="details.question"> -->
<!--            <div class="context">-->
<!--              <p>1. 提取全血基因组，过柱子的时候，发现有时候吸附柱会堵塞。</p>-->

<!--              <p>原因分析及解决办法：</p>-->
<!--            </div>-->
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane label="说明书下载" name="fourth">
            <ul class="down-lists">
              <li v-for="item in details.books" :key="item">
                {{item.name}}
                <div class="xia"><a class="btn btn-primary" size="mini" :download="item.name" :href="item.bookUrl">下载</a></div>
                <a class="btn btn-primary bts"  :download="item.name" :href="item.bookUrl">下载</a>
              </li>
            </ul>
            <div class="no-data" v-show="details.books.length === 0">暂无说明书</div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import bread from "@/components/bread"
import { productGoodsDetail, createCarts, updateCarts, carts } from '@/services/api.index'
import PicZoom from 'vue-piczoom'
export default {
  inject: ['reload'],
  components: {
    Swiper,
    PicZoom,
    bread,
    SwiperSlide
  },
  data () {
    return {
      num: 1,
      specs: '',
      currentPro: 0,
      currentSpecs: 0,
      activeName: 'first',
      details: {},
      cartLists: [],
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 15,
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created() {
    this.getDetails()
    if (this.baseMethods.getLocalObj('userInfo')) {
      this.getCartInfo()
    }
  },
  computed:{
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    getDetails () {
      const id = this.$route.params.id
      productGoodsDetail(id).then(res => {
        res.data.imgUrls.unshift(res.data.mainImgUrl)
        this.details = res.data
      })
    },
    // 获取购物车信息
    getCartInfo () {
      carts().then(res => {
        this.cartLists = res.data
      })
    },
    // 购物车新建
    handleCartChange () {
      const { details, cartLists, currentSpecs, num } = this
      const currentId = details.skus[currentSpecs].id
      const currentCart = cartLists.filter(item => item.sku.id === currentId)
      if (num <= 0) {
        this.$message.error('请添加商品数量')
        return
      }
      if (currentCart.length === 0) {
        createCarts(currentId, num).then(() => {
          this.$message.success('已加入购物车')
          this.reload()
          this.getCartInfo()
        })
      } else {
        updateCarts(currentCart[0].id, currentCart[0].quantity + num).then(() => {
          this.$message.success('已加入购物车')
          this.reload()
          this.getCartInfo()
        })
      }
    },
    shop(){
      const skuCode = this.details.skus.length ? this.details.skus[0].code : ''
      window.open(process.env.SHOP_URL + 'product/sku?skuCode=' + encodeURI(skuCode), '_blank')
    },
    // 立即购买
    toBuy () {
      let { details, currentSpecs, num } = this
      details.skuNum = num
      details.curSku = details.skus[currentSpecs].id
      details.skuDetails = details.skus[currentSpecs]
      this.baseMethods.setLocalObj('goodsInfo', details)
      this.$router.push('/products/chart_confirm')
    },
    swiperPrev() {
      this.swiper.slidePrev();
    },
    swiperNext() {
      this.swiper.slideNext();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/details.vue